// extracted by mini-css-extract-plugin
export default {"SectionTitle":"Experience_SectionTitle__j89Yj"};